import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown } from "lucide-react";

export default function Compare({ spec, tone }) {
  const [open, setOpen] = useState(0);
  const [col, setCol] = useState(0);
  const order = [...spec.rows].map((r, i) => ({ ...r, i }));
  const sorted = col === 0 ? order : [...order].sort((a, b) => String(a.v[col - 1]).localeCompare(String(b.v[col - 1])));

  return (
    <div data-testid="repro-compare">
      <div className="flex flex-wrap gap-2 mb-5">
        <button onClick={() => setCol(0)} className="rounded-full px-4 py-2 text-[12px]"
          style={col === 0 ? { background: tone, color: "#fff" } : { background: "rgba(58,26,42,0.05)", color: "rgba(58,26,42,0.6)" }} data-testid="compare-sort-0">
          As listed
        </button>
        {spec.cols.map((c, i) => (
          <button key={c} onClick={() => setCol(i + 1)} className="rounded-full px-4 py-2 text-[12px]"
            style={col === i + 1 ? { background: tone, color: "#fff" } : { background: "rgba(58,26,42,0.05)", color: "rgba(58,26,42,0.6)" }} data-testid={`compare-sort-${i + 1}`}>
            Sort by {c.toLowerCase()}
          </button>
        ))}
      </div>

      <div className="space-y-2">
        {sorted.map((r, n) => {
          const on = open === r.i;
          return (
            <motion.div key={r.name} layout initial={{ opacity: 0, y: 14 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: Math.min(n * 0.04, 0.3) }}
              className="rounded-[1.4rem] overflow-hidden" style={{ background: on ? "#fff" : "rgba(255,255,255,0.72)", border: `1px solid ${on ? `${tone}44` : "rgba(58,26,42,0.07)"}`, boxShadow: on ? "0 30px 60px -46px rgba(58,26,42,0.8)" : "none" }}
              data-testid={`compare-row-${r.i}`}>
              <button onClick={() => setOpen(on ? -1 : r.i)} className="w-full text-left px-5 sm:px-6 py-4">
                <div className="flex items-center gap-3">
                  <p className="font-display text-[19px] flex-1 min-w-0" style={{ color: "#3A1A2A" }}>{r.name}</p>
                  <ChevronDown size={14} style={{ color: "rgba(58,26,42,0.35)", transform: on ? "rotate(180deg)" : "none", transition: "transform 0.3s" }} />
                </div>
                <div className="grid grid-cols-2 sm:grid-cols-5 gap-x-4 gap-y-2 mt-3">
                  {spec.cols.map((c, i) => (
                    <div key={c}>
                      <p className="text-[9.5px] tracking-[0.14em] uppercase" style={{ color: col === i + 1 ? tone : "rgba(58,26,42,0.38)" }}>{c}</p>
                      <p className="text-[13.5px] mt-0.5" style={{ color: "#3A1A2A", fontWeight: col === i + 1 ? 600 : 400 }}>{r.v[i]}</p>
                    </div>
                  ))}
                </div>
              </button>
              <AnimatePresence initial={false}>
                {on && (
                  <motion.p initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }}
                    className="overflow-hidden px-5 sm:px-6 pb-5 text-[14px] leading-relaxed" style={{ color: "rgba(58,26,42,0.6)" }}>{r.note}</motion.p>
                )}
              </AnimatePresence>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
}
